exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-dark > .panel-heading {\n  color: #fff;\n  background-color: #23b7e5;\n  border-color: #3a3f51;\n  padding: 20px; }\n  .panel-dark > .panel-heading img {\n    height: 30px; }\n\n.wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/login/login.component.scss
// module id = ../../../../../src/app/login/login.component.scss
// module chunks = main